import { object, string, SchemaOf } from "yup";
import { SelectOption } from "@epcnetwork/core-ui-kit";

import { selectMultipleValidation } from "utils";
import { SuppressionTypeOption } from "models";
import { requiredFieldText, searchMinLengthFieldText } from "constants/form.constants";
import {
  CreateSuppressionRequiredValues,
  CreateSuppressionValues,
  UpdateSuppressionRequiredValues,
  UpdateSuppressionValues,
} from "./suppression-form.types";

export const suppressionTypes: SuppressionTypeOption[] = [
  { value: "Email", label: "Email" },
  { value: "Domain", label: "Domain" },
  { value: "Keyword", label: "Keyword" },
  { value: "Regex", label: "Regex" },
];

export const suppressionFilterTypes: SuppressionTypeOption[] = [
  ...suppressionTypes,
  { value: "Regex", label: "Regex" },
];

export const suppressionKindOptions: SelectOption[] = [
  { value: "false", label: "Local" },
  { value: "true", label: "Global" },
];

export const createSuppressionInitialValues = (globalListId?: number): CreateSuppressionValues => ({
  values: "",
  categories: [],
  esps: [],
  listIds: globalListId ? [globalListId] : [],
  type: "Email",
});

export const updateSuppressionInitialValues: UpdateSuppressionValues = {
  categories: [],
  esps: [],
  listIds: [],
};

export const createValidationSchema: SchemaOf<CreateSuppressionRequiredValues> = object().shape({
  values: string().min(3, searchMinLengthFieldText).required(requiredFieldText),
  type: string().required(requiredFieldText),
  listIds: selectMultipleValidation(),
});

export const updateValidationSchema: SchemaOf<UpdateSuppressionRequiredValues> = object().shape({
  listIds: selectMultipleValidation(),
});

/** Special lists (Global / Hard Bounces) cannot mix with local lists. */
export const mapSuppressionListOptions = <
  T extends { isGlobal?: boolean; isHardBounce?: boolean; locked?: boolean },
>(
  options: T[],
  {
    isAdmin,
    selectedLists,
  }: {
    isAdmin: boolean;
    selectedLists: Array<{ isGlobal?: boolean; isHardBounce?: boolean }>;
  },
): T[] => {
  const isSpecial = (option: { isGlobal?: boolean; isHardBounce?: boolean }) =>
    Boolean(option.isGlobal || option.isHardBounce);

  const onlyLocalEnabled = options.map((option) =>
    isSpecial(option) ? { ...option, locked: true } : option,
  );
  const onlySpecialEnabled = options.map((option) =>
    isSpecial(option) ? option : { ...option, locked: true },
  );

  if (!isAdmin) return onlyLocalEnabled;

  const isOptionSelected = selectedLists.length > 0;
  if (!isOptionSelected) return options;
  if (isSpecial(selectedLists[0])) return onlySpecialEnabled;
  return onlyLocalEnabled;
};
